import { Injectable } from '@angular/core';
import { HttpService, CoreService } from '../../../services';
import { Observable } from 'rxjs';
import { PropertyDetailsModel } from '../../../models';
import { b64EncodeUnicode } from '../../../utilities';

@Injectable({
  providedIn: 'root'
})

export class AdminPropDataService {

  constructor(
    protected data: HttpService,
    protected indParam: CoreService
  ) { }

  public GetPropertyComboData(identBO: string, identProp: string, comboField: string): Observable<PropertyDetailsModel> {
    const dt: string = b64EncodeUnicode(`${identBO}|${identProp}|${comboField}`);
    return this.data.getHttp<PropertyDetailsModel>(`${this.indParam.AppParams.apiUrl}api/adminprop/getData/PROPCOMBO/${dt}`);
  }
  public GetGroupoData(groupCode: string): Observable<PropertyDetailsModel> {
    return this.data.getHttp<PropertyDetailsModel>(`${this.indParam.AppParams.apiUrl}api/adminprop/getData/GROUPDATA/${groupCode}`);
  }
  public GetPropertiesByGroup(groupCode: string): Observable<PropertyDetailsModel> {
    return this.data.getHttp<PropertyDetailsModel>(`${this.indParam.AppParams.apiUrl}api/adminprop/getData/GET_PROPERTIES_BY_GROUP_NAME/${groupCode}`);
  }
  public SaveNewItem(model: PropertyDetailsModel): Observable<PropertyDetailsModel> {
    return this.data.postHttp<PropertyDetailsModel>(`${this.indParam.AppParams.apiUrl}api/adminprop/`, model);
  }
}
